"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingButton = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _constants = require("../../constants");
var _customPropTypes = _interopRequireDefault(require("../../util/custom-prop-types"));
var _Button = require("../Button/Button");
var _ButtonGroup = require("../ButtonGroup/ButtonGroup.context");
var _LoadingButton = require("./LoadingButton.styles");
var _excluded = ["buttonType", "fluid", "loading", "loadingVoiceOver", "margin", "marginBottom", "marginLeft", "marginRight", "marginTop", "marginX", "marginY", "size"];
/**
 * A `Button` component with loading state provided by `LoadingMask`.
 *
 * Make sure to add appropriate `loadingVoiceOver` text for assitive technologies.
 *
 * @related ['Button']
 * @extends LoadingMask
 * @since 8.1.0
 */
var LoadingButton = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var buttonType = _ref.buttonType,
    fluid = _ref.fluid,
    loading = _ref.loading,
    loadingVoiceOver = _ref.loadingVoiceOver,
    margin = _ref.margin,
    marginBottom = _ref.marginBottom,
    marginLeft = _ref.marginLeft,
    marginRight = _ref.marginRight,
    marginTop = _ref.marginTop,
    marginX = _ref.marginX,
    marginY = _ref.marginY,
    size = _ref.size,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var context = (0, _react.useContext)(_ButtonGroup.ButtonGroupContext);
  var buttonProps = Object.assign({
    buttonType: context.buttonType || buttonType,
    fluid: context.fluid || fluid,
    size: context.size || size,
    ref: forwardedRef
  }, rest);
  var marginProps = {
    margin: margin,
    marginBottom: marginBottom,
    marginLeft: marginLeft,
    marginRight: marginRight,
    marginTop: marginTop,
    marginX: marginX,
    marginY: marginY
  };
  return /*#__PURE__*/_react.default.createElement(_LoadingButton.StyledLoadingButton, (0, _extends2.default)({
    fluid: context.fluid || fluid,
    loading: loading,
    loadingVoiceOver: loadingVoiceOver,
    iconSize: "sm"
  }, marginProps), /*#__PURE__*/_react.default.createElement(_Button.Button, (0, _extends2.default)({
    disabled: loading
  }, buttonProps)));
});
exports.LoadingButton = LoadingButton;
LoadingButton.displayName = 'LoadingButton';
LoadingButton.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The loading state.
   */
  loading: _propTypes.default.bool,
  /**
   * The `LoadingMask` `loadingVoiceOver` prop.
   */
  loadingVoiceOver: _propTypes.default.string,
  /**
   * A fluid button will take up all horizontal space.
   * Can be inherited from a parent ButtonGroup.
   *
   * Supports inline media query objects
   */
  fluid: _customPropTypes.default.inlineMediaQuery(_propTypes.default.bool),
  /**
   * The size of the button.
   * Can be inherited from a parent ButtonGroup.
   */
  size: _propTypes.default.oneOf(Object.values(_constants.BUTTON_SIZES)),
  /**
   * The type of the button.
   * Can be inherited from a parent ButtonGroup.
   */
  buttonType: _propTypes.default.oneOf(Object.values(_constants.BUTTON_TYPES))
} : {};
LoadingButton.defaultProps = {
  loading: false,
  loadingVoiceOver: 'Loading'
};